import {getPlatform, PLATFORM} from "../MessageDetailsUtils";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import _ from "lodash";

export default function () {
    const params = useParams();
    const messageId = _.get(params, 'id');
    const platform = getPlatform(messageId);

    let message = {};
    let loadingMessage;

    if (platform === PLATFORM.TEAMS) {
        message = useSelector(state => state.messages.teamsMessage);
        loadingMessage = useSelector(state => state.messages.loadingTeamsMessage);
    } else if (platform === PLATFORM.TRENDS) {
        message = useSelector(state => state.messages.trendsMessage);
        loadingMessage = useSelector(state => state.messages.loadingTrendsMessage);
    } else if (platform === PLATFORM.VOTE) {
        message = useSelector(state => state.messages.nextMessage);
        loadingMessage = useSelector(state => state.messages.loadingNextMessage);
    }

    return { message, loadingMessage };
}